/**
 * Parses a Brazilian currency string to a plain number.
 * Supports formats like "R$ 1.234,56" and "1234,56".
 * Returns 0 for empty or unparseable input.
 */
export function parseCurrencyToNumber(value) {
    if (!value || !value.trim())
        return 0;
    var cleaned = value
        .replace("R$", "")
        .replace(/\./g, "")
        .replace(",", ".")
        .trim();
    var parsed = parseFloat(cleaned);
    return isNaN(parsed) ? 0 : parsed;
}
/**
 * Formats a string of digit characters (treated as cents) into a Brazilian
 * currency mask, e.g. "123456" → "R$ 1.234,56".
 */
export function maskCurrency(digits) {
    var num = digits.replace(/\D/g, "");
    if (!num)
        return "R$ 0,00";
    var value = (parseInt(num, 10) / 100).toFixed(2);
    var _a = value.split("."), intPart = _a[0], decPart = _a[1];
    var formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return "R$ ".concat(formattedInt, ",").concat(decPart);
}
